interface MassPasscodeCardProps {
  data: {[x:string]: any}[];
}

export const MassPasscodeCard = ({data = [] }: MassPasscodeCardProps) => {
  return (
    <ul className="bg-white">
      {data.map((row, rowIndex) => (
        <li key={rowIndex} className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl">
          {Object.keys(row ?? {}).map(key => (
            <div className="relative flex items-center justify-between gap-x-6" key={key}>
              <p className="flex-1 text-sm font-semibold leading-6">
                {key}
              </p>
              <p className="flex-1 text-right text-sm leading-6">
                {row[key]}
              </p>
            </div>
          ))}
        </li>
      ))}
    </ul>
  )
}